import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLoaderComponent } from './global-loader.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [GlobalLoaderComponent],
  imports: [CommonModule, SharedModule],
  providers: [],
  exports: [GlobalLoaderComponent],
})
export class GlobalLoaderModule {}
